import api from './client';

const MI_PREFIX = '/prompt-pulse';

/** Unwrap MI API envelope `{ success, data }` with fallback for legacy raw bodies. */
export const unwrapGeoPayload = (response) => (
  response?.data?.data !== undefined ? response.data.data : response?.data
);

// Prompt Pulse dashboard APIs — market-intelligence-backend only (auth via MI + Core API login).

export const getGeoConfig = () => api.get(`${MI_PREFIX}/config`);

export const getGeoSettings = () => api.get(`${MI_PREFIX}/settings`);

export const getGeoQueries = (params) => api.get(`${MI_PREFIX}/queries`, { params });

export const getGeoQueriesCatalog = () => api.get(`${MI_PREFIX}/queries/catalog`);

export const patchGeoQuery = (queryId, body) => api.patch(`${MI_PREFIX}/queries/${queryId}`, body);

export const getGeoInsights = (params) => api.get(`${MI_PREFIX}/insights`, { params });
